
import clsx from 'clsx';
import React from "react";
import Chip from '@material-ui/core/Chip';
import WarningIcon from '@material-ui/icons/Warning';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Typography,
    makeStyles
} from '@material-ui/core';
import { CardHeader } from "../../shared/Card/Index";

import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    avatar: {
        backgroundColor: 'orange',
        height: 56,
        width: 56
    },
    differenceIcon: {
        color: 'green',
    },
    differenceValue: {
        color: 'green',
        marginRight: theme.spacing(1)
    }
}));

const AlertWidget = ({ className, ...rest }) => {
    const classes = useStyles();
    return (
        <Box mt={3}>

            <Card
                className={clsx(classes.root, className)}
                {...rest}
            >
                <CardHeader >
                    <h2 className={classes.cardTitleWhite}>Επιλεχθείσα Ειδοποίηση με Αριθμό: {rest.data.id} </h2>
                </CardHeader>
                <CardContent>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Avatar className={classes.avatar}>
                            <NotificationsActiveIcon />
                        </Avatar>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Τύπος Ειδοποίησης

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.alarmType}
                        </Typography>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Τιμή Ειδοποίησης

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.value}
                        </Typography>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Δείκτης Κινδύνου

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.alarmSeverity}
                        </Typography>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Κατάσταση Ειδοποίησης

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.statusId === 1 ? (<Chip
                                icon={<WarningIcon style={{ color: "white" }} />}
                                label="Ανοιχτή"
                                style={{ backgroundColor: "green", color: "white" }}
                            />

                            ) : rest.data.statusId === 2 ? (
                                <Chip
                                    icon={<WarningIcon style={{ color: "white" }} />}
                                    label="Σε Εξέλιξη"
                                    style={{ backgroundColor: "orange", color: "white" }}
                                />
                            ) : (
                                <Chip
                                    icon={<WarningIcon style={{ color: "white" }} />}
                                    label="Κλειστή"
                                    style={{ backgroundColor: "red", color: "white" }}
                                />
                            )}
                        </Typography>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Τύπος Συσκευής

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.deviceType}
                        </Typography>
                    </Box>
                    <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                    >
                        {/* <ArrowUpwardIcon className={classes.differenceIcon} /> */}
                        <Typography
                            className={classes.differenceValue}
                            variant="body2"
                        >
                            Ημ/νία Ειδοποίησης

                            </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            {rest.data.dateCreated}
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};


export default AlertWidget;